// extracted by mini-css-extract-plugin
module.exports = {"formGrid":"settingsForm_formGrid__mbn_c","title":"settingsForm_title__3T1EP","avatar":"settingsForm_avatar__1xMkf","active":"settingsForm_active__27diO"};